import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-group-mapping-dialog',
  templateUrl: './group-mapping-dialog.component.html',
  styleUrl: './group-mapping-dialog.component.scss'
,  standalone: false
})
export class GroupMappingDialogComponent {

  constructor(private dialogRef: MatDialogRef<GroupMappingDialogComponent>){}

  closeGrpPopUp(){
    this.dialogRef.close();
  }
}
